export interface MetalsLaserMaterial {
  id: string;
  name: string;
  type: MetalsLaserMaterialType;
  thickness: number;
}

export enum MetalsLaserMaterialType {
  Aluminum = 'Aluminum',
  Brass = 'Brass',
  GalvanizedSteel = 'GalvanizedSteel',
  MildSteel = 'MildSteel',
  Other = 'Other',
  Plastic = 'Plastic',
  SpringSteel = 'SpringSteel',
  StainlessSteel = 'StainlessSteel',
}


export interface MetalsPowderCoatingPowder {
  id: string;
  name: string;
  hexValue: string;
}

export interface MetalsPressBrakeBendRadius {
  id: string;
  value: number;
}